import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import MenuItem from 'components/atoms/MenuItem';
import menuItems from 'common/menu_items';
import routeCodes from 'common/constants/route-codes';
import { useCommon } from 'redux/common/use-common';
import { useSettingsStepContext } from 'context/SettingsStepContext';
import { useUser } from 'redux/user/use-user';
import {
  Wrapper,
  List,
  ModalContent,
  ModalDescription,
  ModalList,
} from './styled';
import { PrimaryModal } from 'components/molecules/Modal';

const MobileMenu = ({ open, updateMenuStep }) => {
  const [showAdvancedModal, setShowAdvancedModal] = useState(false);
  const { pathname } = useLocation();
  const { isSuperAdmin } = useUser();
  const { handleGetStripeLink } = useCommon();
  const { resetStep: resetSettingsStep } = useSettingsStepContext();

  const handleOpenAdvancedModal = () => setShowAdvancedModal(true);
  const handleCloseAdvancedModal = () => setShowAdvancedModal(false);

  const getOnClick = (item) => {
    if (item.onClick === 'handleOpenAdvancedModal') {
      return handleOpenAdvancedModal;
    }
    return item.onClick || handleGetStripeLink;
  };

  return (
    <>
      <Wrapper open={open}>
        {isSuperAdmin ? (
          <>
            <List desktop_mb={60}>
              {menuItems.superAdmin.main.map((i) => (
                <MenuItem
                  key={i.label}
                  href={i.href}
                  img={i.img}
                  label={i.label}
                  active={
                    i.href === '/'
                      ? pathname === '/'
                      : pathname.includes(i.href)
                  }
                  onClick={getOnClick(i)}
                  {...i}
                />
              ))}
            </List>
            <List footer={true}>
              {menuItems.superAdmin.footer.map((i, index) => (
                <MenuItem
                  key={i.label}
                  href={i.href}
                  img={i.img}
                  label={i.label}
                  suffix={i.suffix}
                  active={pathname.includes(i.href)}
                  onClick={getOnClick(i)}
                />
              ))}
            </List>
          </>
        ) : (
          <>
            <List>
              {menuItems.main.map((i) => (
                <div
                  key={i.label}
                  onClick={() => {
                    if (i.onClick === 'menuStep') {
                      updateMenuStep('start');
                    }
                    if (i.href === routeCodes.settings) {
                      resetSettingsStep();
                    }
                  }}
                >
                  <MenuItem
                    href={i.href}
                    img={i.img}
                    label={i.label}
                    active={
                      i.href === '/'
                        ? pathname === '/'
                        : pathname.includes(i.href)
                    }
                    onClick={
                      i.onClick === 'menuStep'
                        ? () => {
                            updateMenuStep('start');
                          }
                        : getOnClick(i)
                    }
                    {...i}
                  />
                </div>
              ))}
            </List>
            <List footer={true}>
              {menuItems.footer.map((i) => (
                <MenuItem
                  key={i.label}
                  href={i.href}
                  img={i.img}
                  label={i.label}
                  suffix={i.suffix}
                  active={pathname.includes(i.href)}
                  clickable={i.href === undefined && true}
                  onClick={getOnClick(i)}
                  isFooter={true}
                />
              ))}
            </List>
          </>
        )}
      </Wrapper>

      <PrimaryModal
        showDivider
        open={showAdvancedModal}
        desktopW='760'
        onClose={handleCloseAdvancedModal}
        onCancel={handleCloseAdvancedModal}
        title='Passa a Gestione avanzata'
        hideFooter={true}
      >
        <ModalContent>
          <ModalDescription>Passa alla gestione avanzata per:</ModalDescription>
          <ModalList>
            <li>Attivare i servizi di delivery e asporto</li>
            <li>Buoni VisitBergamo restaurant</li>
            <li>Offerte</li>
            <li>Generare QR code</li>
            <li>Stripe</li>
            <li>Ipratico</li>
          </ModalList>
        </ModalContent>
      </PrimaryModal>
    </>
  );
};

MobileMenu.propTypes = {
  open: PropTypes.bool,
  updateMenuStep: PropTypes.func,
};

export default MobileMenu;
